export default "__VITE_ASSET__DqkmvaWe__"